export const img_300 = "http://image.tmdb.org/t/p/w300";
export const img_500 = "http://image.tmdb.org/t/p/w500";

export const uavailable =
  "http://www.images.githubusercontent.com/img/films/poster-holder.jpg";
